const MEIO_PAGAMENTO_CARTAO_CREDITO = 3;
const MEIO_PAGAMENTO_CARTAO_DEBITO = 4;

function obterIdMeioPagamento(forma = {}) {
  const id =
    forma.id_meio_pagamento ??
    forma.meio_pagamento?.id ??
    forma.paymentMode?.id ??
    null;

  if (id === null || id === undefined || id === "") return null;

  const idNumerico = Number(id);
  return Number.isFinite(idNumerico) ? idNumerico : null;
}

function correspondeAoMeioOuDescricao(forma, idEsperado, descricaoRegex) {
  const idMeioPagamento = obterIdMeioPagamento(forma);

  // O meio selecionado no cadastro é a fonte de verdade. A descrição fica
  // apenas como fallback para registros antigos que ainda não possuem o ID.
  if (idMeioPagamento !== null) return idMeioPagamento === idEsperado;

  return descricaoRegex.test(String(forma?.descricao ?? ""));
}

export function formaEhCartaoCredito(forma) {
  return correspondeAoMeioOuDescricao(
    forma,
    MEIO_PAGAMENTO_CARTAO_CREDITO,
    /cr[eé]dito/i
  );
}

export function formaEhCartaoCredito1x(forma) {
  if (!formaEhCartaoCredito(forma)) return false;

  const vezes = forma?.vezes ?? forma?.parcelas ?? null;
  if (vezes !== null && vezes !== undefined && vezes !== "") {
    return Number(vezes) === 1;
  }

  // Compatibilidade com cadastros antigos que não possuem o campo `vezes`.
  return /\b1\s*x\b/i.test(String(forma?.descricao ?? ""));
}

export function formaEhCartaoDebito(forma) {
  return correspondeAoMeioOuDescricao(
    forma,
    MEIO_PAGAMENTO_CARTAO_DEBITO,
    /d[eé]bito/i
  );
}

export function formaEhCartao(forma) {
  return formaEhCartaoCredito(forma) || formaEhCartaoDebito(forma);
}

export function formaEhCartaoDeAtalho(forma) {
  return formaEhCartaoCredito1x(forma) || formaEhCartaoDebito(forma);
}
